import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as ReviewAttendanceCategories from '../review-attendance-category/review-attendance-category.action';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ReviewAttendanceCategoriesStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new ReviewAttendanceCategories.ReviewAttendanceCategoriesRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.REVIEW_ATTENDANCE_CATEGORY, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ReviewAttendanceCategories.ReviewAttendanceCategoriesCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ReviewAttendanceCategories.ReviewAttendanceCategoriesUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ReviewAttendanceCategories.ReviewAttendanceCategoriesDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ReviewAttendanceCategories.ReviewAttendanceCategoriesRefresh());
          break;
      }
    });
  }
}
